import { useState } from 'react'

export default function TabLayout({ filters, handleChange, loading }) {
  const [activeTab, setActiveTab] = useState('')

  const excludeList = ['District', 'Punishment Type', 'Result De']
  const onTabClick = (id) => {
    setActiveTab(id)
    handleChange({ target: { value: id } }) // mimic <select> onChange
  }
  // nav-pills
  return (
    <ul className="nav flex-column nav-tabs me-3" style={{ minWidth: '200px' }}>
      {/* <ul className=" nav nav-tabs "> */}

      {filters
        .filter(option => !excludeList.includes(option.value))
        .map((option) => (
          <li className="nav-item" key={option.id}>
            <button
              className={`nav-link ${activeTab === option.id ? 'active bg-dark text-white' : ''
                }`}
              onClick={() => onTabClick(option.id)}
              disabled={loading}
            >
              {option.value}
            </button>
          </li>
        ))}
    </ul>
  )
}
